import './index.css';
import App from './App';
import React from 'react';
import ReactDOM from 'react-dom';
import {amplifyConfig} from "./AmplifyConfig";
import * as serviceWorker from './serviceWorker';
import {BrowserRouter as Router} from 'react-router-dom';
import {Amplify} from "aws-amplify";

Amplify.configure(amplifyConfig);

ReactDOM.render(
    <Router>
        <App/>
    </Router>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
